import React, { useState } from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import { ENTITY_COLOR_UID_MAP } from "components/FormerEditor/common/constants/entity";
import { COLORS } from "utils/styles";
import classnames from "classnames";
import Pill from "components/Pill";
import startCase from "lodash/startCase";
import { UI_THEME } from "utils/constants/ui";

const BlockOption = ({
  uid,
  label,
  onClick,
  canSelect,
  validation,
  schema,
  pill
}) => {
  const max = validation && validation.max;
  const parents = validation && validation.parents;
  const [hover, setHover] = useState();
  const Icon = getIconForUID(uid);
  const color = ENTITY_COLOR_UID_MAP[uid] || COLORS.primary;

  const containerProps = {
    className: classnames("pt3 ph3 bh--inset flex flex-row bb hairline-1", {
      "bg-content--secondary": hover && canSelect,
      "bg-white": !hover || !canSelect,
      "cursor-not-allowed": !canSelect,
      "pointer": canSelect,
      "pb3": !max
    }),
    onClick,
    onMouseEnter: () => !hover && canSelect && setHover(true),
    onMouseLeave: () => hover && canSelect && setHover(false)
  };

  let requiredParents;
  if (parents && parents.length > 0) {
    const message = parents.map((parent) => startCase(parent)).join(", ");
    requiredParents = (
      <div className="pl3 f6 pt2 fw5 lh-copy">{`Requires: ${message}`}</div>
    );
  }

  return (
    <div {...containerProps}>
      {Icon && (
        <div
          style={{ height: 28, width: 28 }}
          className={
            "flex items-center justify-center bg-content--secondary br2 icon--boundary flex-shrink-0"
          }
        >
          <Icon size={16} color="#ffffff" />
          <style jsx>{`
            .icon--boundary {
              background-color: ${color};
            }
          `}</style>
        </div>
      )}
      <div className="flex flex-column w-100">
        <div
          className={classnames("flex flex-column pl3", {
            "o-40": !canSelect
          })}
        >
          <div className="flex flex-row">
            <div className={"fw6 f5"}>{label}</div>
            {pill && <Pill theme={UI_THEME.SLIM} copy={pill} />}
          </div>
          {schema && (
            <div className={`f6 pt${pill ? 1 : 2} lh-copy`}>
              {schema.description}
            </div>
          )}
        </div>
        {requiredParents}
        {max && <Pill copy={`Max ${max}`} />}
      </div>
    </div>
  );
};

export default BlockOption;
